import {
  Button as RadixButton,
  ButtonProps as RadixButtonProps,
} from "@radix-ui/themes";
import { FC } from "react";

type ButtonProps = Pick<
  RadixButtonProps,
  "onClick" | "children" | "loading" | "disabled"
>;

export const Button: FC<ButtonProps> = (props) => {
  return <RadixButton {...props} />;
};
